import React from 'react';
import { FormControlLabel, Switch, SxProps, Theme, Typography } from '@mui/material';

import { BCRestraintSegments } from '@paragon/contract-library';

interface Props {
  readonly disabled?: boolean;
  readonly onUpdate: <K extends keyof BCRestraintSegments>(key: K, value: boolean | number, index: number) => void;
  readonly sx: SxProps<Theme>;
  readonly index: number;
  readonly fromLeft: boolean;
}

export class RestraintToggle extends React.Component<Props> {
  onChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    this.props.onUpdate('fromLeft', checked, this.props.index);
  };

  render() {
    return (
      <>
        <Typography>From Left</Typography>
        <FormControlLabel
          control={
            <Switch
              color="default"
              sx={this.props.sx}
              checked={this.props.fromLeft}
              disabled={this.props.disabled}
              onChange={this.onChange}
            />
          }
          label="From Right"
        />
      </>
    );
  }
}
